
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wekan-wiki-9-cloudron.json") })
        }
      }, "path---wekan-wiki-9-cloudron");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---wekan-wiki-9-cloudron!./.cache/json/wekan-wiki-9-cloudron.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---wekan-wiki-9-cloudron!./.cache/json/wekan-wiki-9-cloudron.json
// module chunks = 154